import './index.css';

export default {
  name: 'Arow',
  props: {
    gutter: { type: Number | String, default: () => 14 },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    const { width = null, height = null, margin = null } = this.$attrs;
    return ({
      width,
      height,
      margin,
    });
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      this.gutter && (this.margin = (`${-(parseInt(this.gutter) / 2)}px`));
      this.flex && this.$nextTick(() => {
        !this.width && (this.width = (`${this.$el.clientWidth}px`));
        !this.height && (this.height = (`${this.$el.clientHeight}px`));
      });
    },
  },
  render() {
    const { padding = null, ...attrs } = this.$attrs;
    return (
      <el-row
        style={{ padding, margin: this.margin, width: this.width, height: this.height }}
        class={['a-row', (this.flex ? 'flex' : null)]}
        gutter={parseInt(this.gutter)}
        {...{ attrs }}
      >
        {this.$slots.default}
      </el-row>
    );
  }
}